import React from "react";
import styles from "./auth-page-layout.module.scss";
import { useTenant } from "../../../../tenant/branding/useTenant";
import { TenantLogo } from "../../../../tenant/branding/TenantLogo";

interface AuthPageLayoutProps {
	children: React.ReactNode;
}

export const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({ children }) => {
	const { poweredBy } = useTenant();
	return (
		<div className={styles.pageContainer}>
			<div className={styles.content}>
				{children}
			</div>
			{poweredBy && (
				<div className={styles.footer}>
					<span className={styles.footerText}>Powered by </span>
					<hr className={styles.divider} />
					<TenantLogo logo={poweredBy.logo} alt={poweredBy.name} />
				</div>
			)}
		</div>
	);
};
